import React from 'react';

export const EmptyState: React.FC<{}> = (props: any) => (
  <div className="empty-state--container">{props.children}</div>
);
EmptyState.displayName = 'EmptyState';
export default EmptyState;
